import React, { useState } from 'react';
const faqs = [{
  q: 'È adatto sia per media che superiore?',
  a: 'Sì, il materiale è strutturato in modo progressivo e include moduli specifici sia per la scuola secondaria di primo grado che per quella di secondo grado.'
}, {
  q: 'Posso stampare il materiale?',
  a: 'Assolutamente sì. Tutti i PDF sono ad alta risoluzione e ottimizzati per la stampa in formato A4, perfetti da distribuire agli studenti.'
}, {
  q: "Ricevo tutti i bonus con l'offerta di oggi?",
  a: "Sì, acquistando oggi durante l'offerta speciale riceverai gratuitamente tutti i 6 bonus esclusivi (valore €67)."
}, {
  q: 'È adatto ai docenti alle prime armi?',
  a: "È perfetto per chi inizia a insegnare perché fornisce una struttura solida e un percorso già tracciato, togliendo l'ansia della pianificazione da zero."
}, {
  q: 'Per quanto tempo avrò accesso?',
  a: "L'accesso è a vita. Una volta scaricato, il kit è tuo per sempre, senza abbonamenti o costi ricorrenti."
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì, utilizziamo gateway di pagamento criptati e sicuri al 100%. Accettiamo tutte le principali carte di credito e debito.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-121">
      <div className="max-w-3xl mx-auto" data-id="element-122">
        <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main text-center mb-12 tracking-tight" data-id="element-123">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-124">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(30,142,90,0.1)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-125">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-126">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-127">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-128">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-129">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-130">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-131">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-132"></div>
          <h3 className="text-2xl sm:text-3xl font-montserrat font-black text-text-main mb-6 relative z-10" data-id="element-133">
            Pronto a cambiare il tuo modo di insegnare?
          </h3>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Biologia Pronta — Il Kit Completo',
              content_type: 'product',
              value: 19.9,
              currency: 'EUR'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-montserrat font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(30,142,90,0.3)] border border-white/20" data-id="element-134">
            🚀 SÌ! VOGLIO TRASFORMARE LE MIE LEZIONI DI BIOLOGIA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-135">
            <span data-id="element-136">⚡ Accesso Immediato</span>
            <span data-id="element-137">•</span>
            <span data-id="element-138">🛡️ Garanzia di 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}